import { useRef } from 'react';
import { FormHelperText, Grid } from '@mui/material';
import { FormikProps } from 'formik';
import Editor from '../../common/editor/Editor';
import { type RichTextEditorRef } from 'mui-tiptap';
import { SecondarySubject } from '../../../types/Comment';

export interface CommentInput {
  id: string;
  subjectId?: string;
  resourceType?: number;
  comment: string;
  secondarySubjects?: SecondarySubject[];
}

interface CommentProps {
  formRef: FormikProps<CommentInput>;
}

export default function AddComment(props: CommentProps) {
  const rteRef = useRef<RichTextEditorRef>(null);
  return (
    <form onSubmit={props.formRef.handleSubmit} style={{ width: '100%' }}>
      <Grid container spacing={3}>
        <Grid xs={12} sm={12} lg={12} item>
          <Grid xs={12} item>
            <Editor
              autoFocus={true}
              contents={props.formRef.values.comment}
              rteRef={rteRef}
              onUpdate={(e) => {
                props.formRef.setFieldValue('comment', rteRef.current?.editor?.getHTML() ?? '');
              }}
            />
            <FormHelperText error={props.formRef.touched?.comment && Boolean(props.formRef.errors?.comment)}>
              {props.formRef.touched?.comment && props.formRef.errors?.comment}
            </FormHelperText>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
